<template>
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="28"
      y="14"
      width="59"
      height="86.2784"
      rx="3"
      fill="white"
      stroke="#4D4E58"
      stroke-width="4"
    />
    <rect
      x="70"
      y="16"
      width="15"
      height="83"
      fill="#E0E5FF"
    />
    <rect
      x="28"
      y="14"
      width="59"
      height="86.2784"
      rx="3"
      stroke="#4D4E58"
      stroke-width="4"
    />
    <rect
      x="50"
      y="32"
      width="31"
      height="5"
      rx="2"
      fill="#4D4E58"
    />
    <rect
      x="35"
      y="32"
      width="11"
      height="5"
      rx="2"
      fill="#4D4E58"
    />
    <rect
      x="35"
      y="62"
      width="11"
      height="5"
      rx="2"
      fill="#4D4E58"
    />
    <rect
      x="50"
      y="47"
      width="31"
      height="5"
      rx="2"
      fill="#7B90FF"
    />
    <rect
      x="50"
      y="62"
      width="31"
      height="5"
      rx="2"
      fill="#4D4E58"
    />
    <path
      d="M36 46.8966L39.7143 51L46 44"
      stroke="#7B90FF"
      stroke-width="3"
    />
    <circle
      cx="90.0003"
      cy="89.9996"
      r="16.6667"
      transform="rotate(-180 90.0003 89.9996)"
      fill="#7B90FF"
    />
    <path
      d="M90 83V90.186L95.314 95.5"
      stroke="white"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
